window.getBackButtonHref = function (id) {
    let backButton = $('#'+id);
    if (!backButton.length) {
        backButton = $('.back-button');
    }
    
    if(backButton.length) {
        id = backButton[0].id;
        if (localStorage.getItem("backButtonHref")) {
            backButton.attr("href", localStorage.getItem("backButtonHref"));
            localStorage.setItem(id, localStorage.getItem("backButtonHref"));
        } else if(localStorage.getItem(id)) {
            backButton.attr("href", localStorage.getItem(id));
        }
    }
    return;
};

window.saveBackButtonHrefValue = function () {
    if (localStorage.getItem('from-back') != 1) {
        localStorage.setItem('backButtonHref', window.location.href);
    } else if (localStorage.getItem('backButtonHref')) {
        if (localStorage.getItem('submitted') != 1) {
            localStorage.removeItem('backButtonHref');
        } else {
            localStorage.removeItem('submitted');
        }
    }
    localStorage.setItem('from-back', 0);
}

window.addEventListener("beforeunload", saveBackButtonHrefValue);

window.addEventListener('load', 
    function() { 
        getBackButtonHref('backButton');
    }, true);

if (typeof goBack !== "function") {
    window.goBack = function(backButton, submitted = false) {
        localStorage.removeItem(backButton.id);
        localStorage.setItem('from-back',1);
        if (!submitted) {
            if (!backButton.href || backButton.href == "") {
                window.history.back();
            }
        } else {
            localStorage.setItem('submitted',1);
        }
    }    
}


// WEBPACK FOOTER //
// ./resources/assets/js/backButtonHrefSetter.js